import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaComponent, ReCaptchaService } from 'angular-recaptcha3';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ComboComponent, ItemData } from 'sharedGuiSmall/components';
import { Utils } from "sharedGuiSmall/utils/utils";
import { AuthAppService } from "sign-up-app/services/auth.service";
import { RegisterUser } from "sign-up-app/sign-up/RegisterUser";

declare var grecaptcha: ReCaptchaComponent;

@Component({
    selector: 'xero-creation',
    templateUrl: './xero-creation.component.html',
    styleUrls: ['./xero-creation.component.less']
})
export class XeroCreationComponent implements OnInit, OnDestroy {

    @ViewChild('positionWrongMsg')
    private positionWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('positionsCombo')
    private positionsCombo!: ComboComponent;

    @ViewChild('passwordInput')
    private passwordInput!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordWrongMsg')
    private passwordWrongMsg!: ElementRef<HTMLDivElement>;

    @ViewChild('pwdHints')
    private pwdHints!: ElementRef<HTMLDivElement>;
    
    unsubscribe: Subject<void> = new Subject<void>();

    newUser = new RegisterUser();

    positions: Array<ItemData> = [{ id: 7, value: 'other', disabled: false }];

    isPasswordValid: boolean = false;
    isPositionValid: boolean = false;

    fullLiveUrl = window.fullLiveUrl;
    firstName = "";
    lastName = "";

    isAfterGetResponse: boolean = false;

    signUpButtonText = $localize`Sign up for free`;
    constructor(
        private router: Router,
        private authService: AuthAppService,
        private recaptchaService: ReCaptchaService,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(x => {
            this.firstName = x.firstName;
            this.lastName = x.lastName;
        });
        this.newUser.getNews = Utils.getCookie("isGetNews").toLowerCase() == "true";
        const getResponseEmail = localStorage.getItem('getResponseEmail') ?? '';
        const selectedPositionId = localStorage.getItem('selectedPositionId') ?? '';
        //TODO remove xero related code if its unused after BR-8913
        this.isAfterGetResponse = !Utils.isNullOrEmpty(getResponseEmail);

        if (this.isAfterGetResponse) {
            this.newUser.email = getResponseEmail;
            this.newUser.selectedPositionId = parseInt(selectedPositionId);
        }

        this.authService.LoadPositions();

        if (this.authService.positionsPromise)
            this.authService.positionsPromise.then(data => {
                if (typeof (data.data?.Positions) == "undefined") return;
                this.positions = this.getComboItems(data.data.Positions);
            });
    }

    goToSignIn(): void {
        window.location.href = this.fullLiveUrl+'/sign-in';
    }

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }

    toggleGetNews(): void {
        this.newUser.getNews = !this.newUser.getNews;
    }

    onPasswordType() {
        this.authService.ProcessPasswordHints(this.newUser.passwordStr, this.pwdHints, 8);
    }

    validatePassword(): void {
        this.isPasswordValid = this.authService.ValidateField(this.passwordInput, this.passwordWrongMsg, this.newUser.passwordStr, ['required','minlength 8','uppercase','lowercase','special','maxlength 48'],
            {'required': 'The Password field must be completed', 'minlength': 'Minimum password length 8 characters', 'uppercase': 'Does not meet password requirements',
                'lowercase': 'Does not meet password requirements', 'special': 'Does not meet password requirements',
                'maxlength': 'Maximum password length 48 characters'});
    }

    validatePositions(): void {
        if (this.newUser.selectedPositionId)
            this.isPositionValid = this.authService.ValidateField(undefined, this.positionWrongMsg, this.newUser.selectedPositionId+'', ['required'], {'required': 'The position field must be completed'});
    }

    getComboItems(itemsDto: any): ItemData[] {
        let result = [];
        if (itemsDto)
            for (let i = 0; i < itemsDto.length; i++) {
                let item = new ItemData();
                item.id = itemsDto[i].ID === 0 ? -1 : itemsDto[i].ID;
                item.value = itemsDto[i].Name;
                result.push(item);
            }

        return result;
    }

    signUp(): void {
        this.validatePassword();

        if (this.isPasswordValid) {
            this.recaptchaService.execute();
        }
        else {
            console.error('validation failed');
        }
    }

    signUpWithXero(): void {
        this.isPositionValid = this.authService.ValidateField(undefined, this.positionWrongMsg, this.newUser.selectedPositionId+'', ['required'], {'required': 'The position field must be completed'});
        if (this.isPositionValid) {
            this.authService.toggleSpinner();

            this.authService.SignUpWithXero(this.newUser.selectedPositionId, this.newUser.getNews, this.firstName, this.lastName).then((res: string) => {
                let data = { newUserId:0, integrationEmail:'', userHasInvites:false, companyToWhichUserInvited:'', success:true, errorMessage:'' };

                if (res && res.length && res.indexOf("error=sessiontimeout") === -1) {
                    data = JSON.parse(res);

                    localStorage.setItem("brixx-email", data.integrationEmail);

                    window.location.href = this.fullLiveUrl + 'brixx-start';
                }
            });
        }
    }
    
    onCaptchaResponse(token: string): void {
        this.authService.toggleSpinner();
        this.newUser.captchaText = token;
        this.newUser.password = this.newUser.passwordStr;

        if (this.isAfterGetResponse)
            localStorage.setItem("brixx-email", this.newUser.email);

        const newUser = JSON.stringify(this.newUser);
        this.authService.RegisterUser(newUser).then((res: string) => {
            let data = { newUserId: 0, integrationEmail: '', userHasInvites: false, companyToWhichUserInvited: '' };

            if (res && res.length && res.indexOf("error=sessiontimeout") === -1) {
                data = JSON.parse(res);

                localStorage.setItem('integrationEmail', data.integrationEmail);

                window.location.href = this.fullLiveUrl + 'brixx-start';
            }
        });
    }
    
    ngOnDestroy(){
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
